<template>
  <div class="page-wrapper storybook-cnc-button">
    <StorybookTemplate
      title="CncButton"
      pathComponent="/shared/elements/global/v1/CncButton.vue"
      :propList="propListFilter"
      :form.sync="form"
    >
      <CncButton v-bind="form">{{ form.name }}</CncButton>
    </StorybookTemplate>
  </div>
</template>

<script>
export default {
  components: {
    StorybookTemplate: () => import('../../../../components/StorybookTemplate.vue')
  },
  data () {
    return {
      propList: [
        { name: 'name', type: 'input', param: 'name' },
        {
          name: 'type',
          type: 'select',
          param: 'type',
          default: 'filled',
          option: [
            { label: 'filled', name: 'Filled' },
            { label: 'tonal', name: 'Tonal' },
            { label: 'tonal-outlined', name: 'Tonal outlined' },
            { label: 'tonal-alt', name: 'Tonal alt' },
            { label: 'tonal-alt-outlined', name: 'Tonal alt outlined' },
            { label: 'neutral', name: 'Neutral' },
            { label: 'neutral-outlined', name: 'Neutral outlined' },
            { label: 'ghost', name: 'Ghost' },
            { label: 'filled-on-color', name: 'Filled on color' },
            { label: 'outline-on-color', name: 'Outline on color' }
          ]
        },
        {
          name: 'size',
          type: 'select',
          param: 'size',
          default: 'large',
          option: [
            { label: 'small', name: 'Small' },
            { label: 'medium', name: 'Medium' },
            { label: 'large', name: 'Large' }
          ]
        },
        {
          name: 'typeWidth',
          type: 'select',
          param: 'typeWidth',
          default: 'hug',
          option: [
            { label: 'hug', name: 'Hug' },
            { label: 'fixed', name: 'Fixed' },
            { label: 'fill', name: 'Fill' }
          ]
        },
        { name: 'width', type: 'slider', param: 'width', min: 0, max: 300 },
        {
          name: 'leftIcon',
          type: 'object',
          param: 'leftIcon',
          objectKey: [
            { key: 'name', type: 'input', value: 'IconHome' },
            { key: 'isTwoTone', type: 'boolean', value: 'false' },
            { key: 'isSolid', type: 'boolean', value: 'false' }
          ]
        },
        {
          name: 'rightIcon',
          type: 'object',
          param: 'rightIcon',
          objectKey: [
            { key: 'name', type: 'input', value: 'IconSquareRight' },
            { key: 'isTwoTone', type: 'boolean', value: 'false' },
            { key: 'isSolid', type: 'boolean', value: 'false' }
          ]
        },
        { name: 'loading', type: 'boolean', param: 'loading' },
        { name: 'disabled', type: 'boolean', param: 'disabled' },
        { name: 'isAbbreviated', type: 'boolean', param: 'isAbbreviated' },
        { name: 'badgeNumber', type: 'slider', param: 'badgeNumber', min: 0, max: 10000000 }
      ],

      form: {
        name: 'Button',
        typeWidth: 'hug',
        type: 'filled',
        size: 'medium',
        width: 200,
        loading: false,
        disabled: false,
        badgeNumber: 6,
        isAbbreviated: false,
        leftIcon: { name: 'ico_plus_circle', isTwoTone: false },
        rightIcon: { name: 'ico_ai', isTwoTone: true }
      }
    }
  },
  computed: {
    propListFilter () {
      if (['hug', 'fill'].includes(this.form.typeWidth)) return this.propList.filter(prop => prop.param !== 'width')
      if (!this.form.badgeNumber) return this.propList.filter(prop => prop.param !== 'isAbbreviated')
      return this.propList
    }
  }
}
</script>
